import React from "react";
import { Box, Typography } from "@mui/material";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import { branchLabelFor } from "../utils/branchDisplay";

const BranchChip = ({
  // Either pass the row itself, or the three values by hand.
  row,
  branchName = row?.branch_name,
  branchCode = row?.branch_code,
  storeName = row?.store_name,
  // How many branches the store has, when the caller knows. Unknown counts as
  // one, which suppresses a same-named branch — see branchLabelFor.
  branchCount,
  dense = false,
  sx = {},
}) => {
  const label = branchLabelFor({ branchName, storeName, branchCount });
  if (!label) return null;

  return (
    <Box
      // The code is in the tooltip rather than on the chip: it is what people
      // say out loud and type into other systems, but it would double the
      // chip's width on a list row that already carries a store and a ticket
      // number.
      title={branchCode ? `Branch ${label} (${branchCode})` : `Branch ${label}`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.25,
        flexShrink: 0,
        maxWidth: dense ? 110 : 150,
        px: 0.5,
        py: dense ? 0 : 0.1,
        borderRadius: "6px",
        bgcolor: "#EFF6FF",
        border: "1px solid #BFDBFE",
        ...sx,
      }}
    >
      <PlaceRoundedIcon
        sx={{ fontSize: dense ? 9 : 11, color: "#1E40AF", flexShrink: 0 }}
      />
      <Typography
        noWrap
        sx={{
          fontSize: dense ? 9 : 10,
          fontWeight: 600,
          color: "#1E40AF",
          lineHeight: 1.4,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default BranchChip;
